/**
 * Configuración centralizada para servicios de IA
 */

// Obtener API key desde variables de entorno o fallback
export const API_KEY = process.env.GEMINI_API_KEY || 'AIzaSyDBD7behhp9LVD2vuoSuzDhn3i4R2vohgI'

// Modelos disponibles
export const AI_MODELS = {
  FLASH: 'gemini-2.5-flash',
  FLASH_LITE: 'gemini-2.5-flash-lite',
  FLASH_2_0: 'gemini-2.0-flash',
  PRO: 'gemini-pro'
}

// Configuración por defecto para componentes
export const DEFAULT_AI_CONFIG = {
  models: {
    CLEAN: AI_MODELS.FLASH,
    CONFIDENCE: AI_MODELS.FLASH_LITE,
    FINAL_CONFIDENCE: AI_MODELS.FLASH_LITE
  },
  batch: {
    size: 10,
    delay: 100
  },
  thresholds: {
    pinitActivation: 90,
    pinitCoordinates: 0.9,
    badgeSuccess: 90,
    badgeWarning: 75,
    badgeInfo: 50
  },
  pinit: {
    enabled: false,
    validation: true,
    geocoding: true,
    countries: ['MX']
  },
  thinking: {
    budget: 0 // 0 = disabled, -1 = dynamic
  }
}

export default {
  API_KEY,
  AI_MODELS,
  DEFAULT_AI_CONFIG
}
